import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { FormBuilder, Validators, FormGroup, FormArray, FormControl } from '@angular/forms';
import { Sign } from '@app/models/sign';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { ClaimsService } from '@app/services/claims/claims.service';
import { Enumroles } from '@app/models/enumroles.enum';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MemberShort } from '@app/models/member';
import { Router } from '@angular/router';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { Observable, Subscription } from 'rxjs';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { startWith, map } from 'rxjs/operators';

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

@Component({
  selector: 'app-addsign',
  templateUrl: './addsign.component.html'
})
export class AddsignComponent implements OnInit, OnChanges, OnDestroy {
  @Input() memberid: number;
  @Input() baseinfo: any;
  @Input() isAdmin: boolean;
  @Input() isSysAdmin: boolean;
  @Input() isClerk: boolean;
  @Input() admininstitutions: number[];
  @Output() valueChange = new EventEmitter();
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  signs: Sign[] = [];
  institutionlist: LodgeAndCamp[] = [];
  // baseinfo;
  selectedSignsForm: FormGroup;
  subscriptions: Subscription[] = [];
  members: MemberShort[] = [];
  selectedmembers: MemberShort[] = [];

  /* start autocomplete */
  myControl = new FormControl();
  items: FormArray;
  data: LodgeAndCamp[] = [];
  filteredOptions: Observable<LodgeAndCamp[]>;
  selectedinstitution: any;
  selectedinstitutionname: string;
  /* end autocomplete */

  // tslint:disable-next-line:max-line-length
  constructor(private fb: FormBuilder, private memberOfficeService: MemberofficeService, private institutionsService: InstitutionsService, private claimsService: ClaimsService, private router: Router, private snackbarService: SnackbarService) { }
form;
 
  ngOnInit() {
    this.form = this.fb.group({
      institutionId: ['', Validators.required],
      signId: ['', Validators.required],
      fromDate: ['', Validators.required]
    });
  
    if (this.claimsService.isClerk() || this.claimsService.isSysAdmin()) {
      this.subscriptions.push(this.institutionsService.getInstitutions().subscribe(data => {
        if (data) {
          data.forEach(element => {
            const inst = { id: element.id, shortName: element.shortName, name: element.name };
            this.data.push(inst);
          });
        }

        if (this.claimsService.isClerk() || this.claimsService.isSysAdmin()) {
          this.subscriptions.push(this.institutionsService.getInstitutions().subscribe(data1 => {
            if (data1) {
              data1.forEach(element => {
                const inst = { id: element.id, shortName: element.shortName, name: element.name };
                this.data.push(inst);
              });
            }
            /* start autocomplete */

            this.filteredOptions = this.myControl.valueChanges
              .pipe(
                startWith<string | LodgeAndCamp>(''),
                map(value => typeof value === 'string' ? value : value.name),
                map(name => name ? this._filter(name) : this.data.slice())
              );
            /* end autocomplete */
          }));
        }
      }));
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.admininstitutions) {
      this.admininstitutions = changes.admininstitutions.currentValue;
      this.listClaims();
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  cancel() {
    this.valueChange.emit('cancelAddSign');
    this.router.navigate(['/memberform/id/', this.memberid]);
  }

  /* start autocomplete */
  private _filter(name: string): LodgeAndCamp[] {
    const filterValue = name.toLowerCase();
    // tslint:disable-next-line:max-line-length
    return this.data.filter(option => option.name.toLowerCase().indexOf(filterValue) !== -1 || option.shortName.toLowerCase().indexOf(filterValue) !== -1);
  }

  getPossibleSigns(institutionId: number) {
    if (institutionId === 0) {
      this.signs = [];
    } else {
      this.subscriptions.push(this.memberOfficeService.GetPossibleSigns(institutionId).subscribe(data => {
        this.signs = data;
      }));
    }
  }

  getPossibleSignsEvent(event: any) {
    const institutionId = event.target.value;
    if (institutionId === 0) {
      this.signs = [];
    } else {
      this.subscriptions.push(this.memberOfficeService.GetPossibleSigns(institutionId).subscribe(data => {
        this.signs = data;
      }));
    }
  }

  saveSign() {
    const signslist = [];
    const sign = {
      memberId: Number(this.memberid),
      institutionId: Number(this.form.get('institutionId').value),
      signId: Number(this.form.get('signId').value),
      action: 'add',
      date: this.form.get('fromDate').value
    };

    signslist.push(sign);

    this.subscriptions.push(this.memberOfficeService.UpdateMemberSign(signslist).subscribe(response => {
      if (response) {
        if (response[0].status === 'ok') {
          this.valueChange.emit('signAdded');
          this.router.navigate(['/memberform/id/', this.memberid]);
          this.snackbarService.openSnackBar('Utmärkelsen tillagd', null);
        }
      }
    }));
  }

  onSelectionChanged(event: MatAutocompleteSelectedEvent) {
    this.clearSelectedSignsForm();
    this.selectedinstitution = event.option.value.id;
    this.form.get('institutionId').setValue(event.option.value.id);
    this.getSignsByInstitutionId(event.option.value.id);
    this.selectedinstitutionname = event.option.value.shortName + ' ' + event.option.value.name;
  }

  getSignsByInstitutionId(institutionid: number) {
    this.signs = [];
    this.getPossibleSigns(institutionid);
    if (this.members.length > 0) {
      this.members = [];
    }
  }

  clearSelectedSignsForm() {
    if (this.selectedSignsForm) {
      const controllength = this.selectedSignsForm.controls.items.value.length;
      for (const c of this.selectedSignsForm.controls.items.value) {
        this.removeFromArray(c.memberId);
      }
    }
  }

  removeSelectedMember(id: number) {
    const elementidx = this.selectedmembers.findIndex(obj => obj.id === id);
    this.selectedmembers.splice(elementidx, 1);
  }

  removeFromArray(id: number) {
    const idx = this.members.findIndex(item => item.id === id);
    this.members[idx].checked = false;
    this.items.removeAt(this.items.value.findIndex(item => item.memberId === id));
    this.removeSelectedMember(id);
  }

  listClaims() {
    this.institutionlist = [];
    this.baseinfo.claimsList.forEach(element => {
      if (element.key === Enumroles.ADMIN_LODGE || element.key === Enumroles.ADMIN_CAMP) {
        const lodgeOrcamp: LodgeAndCamp = {
          id: element.value.id,
          shortName: element.value.shortName,
          name: element.value.name
        };
        this.institutionlist.push(lodgeOrcamp);
      }
    });

    const tempinstitutionlist = [];
    this.institutionlist.forEach(i => {
      if (this.admininstitutions.indexOf(i.id) !== - 1) {
        tempinstitutionlist.push(i);
      }
    });
    this.institutionlist = tempinstitutionlist;
  }

  clear() {
    this.myControl.setValue(null);
  }

}
